import { render, staticRenderFns } from "./BasicDetails.vue?vue&type=template&id=337c1435&scoped=true&"
import script from "./BasicDetails.vue?vue&type=script&lang=js&"
export * from "./BasicDetails.vue?vue&type=script&lang=js&"
import style0 from "./BasicDetails.vue?vue&type=style&index=0&id=337c1435&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337c1435",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337c1435')) {
      api.createRecord('337c1435', component.options)
    } else {
      api.reload('337c1435', component.options)
    }
    module.hot.accept("./BasicDetails.vue?vue&type=template&id=337c1435&scoped=true&", function () {
      api.rerender('337c1435', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Survey/BasicDetails.vue"
export default component.exports